import { actions } from './actions';
import config from './config';
import guards from './guards';
import * as services from './services';

const options = {
  actions,
  guards,
  services,
};

export { config, options };
